module.exports = __webpack_public_path__ + "static/media/15.c1bff530.mp3";